export default __webpack_public_path__ + "static/about-6-fc70330eb64755a9f818244a94a2ef6f.png";